export function getSafeInternalAppPath(
    value: unknown,
    origin = typeof window === "undefined" ? "https://mystudio.invalid" : window.location.origin,
): string {
    const source = String(value || "").trim();
    if (!source.startsWith("/") || source.startsWith("//")) return "";

    try {
        const target = new URL(source, origin);
        const expectedOrigin = new URL(origin).origin;
        if (target.origin !== expectedOrigin) return "";
        return `${target.pathname}${target.search}${target.hash}`;
    } catch {
        return "";
    }
}

export function getSafeHttpsDownloadUrl(value: unknown): string {
    const source = String(value || "").trim();
    if (!source) return "";

    try {
        const target = new URL(source);
        const loopbackHttp = target.protocol === "http:"
            && ["127.0.0.1", "localhost", "[::1]"].includes(target.hostname.toLowerCase());
        return target.protocol === "https:" || loopbackHttp ? target.href : "";
    } catch {
        return "";
    }
}

export function openSafeHttpsDownloadUrl(
    value: unknown,
    assign: (url: string) => void = (url) => window.location.assign(url),
): boolean {
    const safeUrl = getSafeHttpsDownloadUrl(value);
    if (!safeUrl) return false;
    assign(safeUrl);
    return true;
}
